 
import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './howthingswork.json';

const Howthingswork = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Technical English for explaining processes and mechanisms. B2 level grammar, vocabulary, and reading comprehension exercises."
            level="B2"
            title="How Things Work"
            image="/Images/education1.webp"
            seoTitle="Free English Lesson Plans: How Things Work"
            seoDescription="Technical English for explaining processes and mechanisms. B2 level grammar, vocabulary, and reading comprehension exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Howthingswork;


